export const INVITATORY_ANTIPHONS: { [id: string]: [string, string] } = {
    advent: [
        "Our King and /Sav_iour /draw_eth /nigh;",
        "O come, let /us a_/dore him",
    ],
    christmas: [
        "Al_le_lu_ia. Un_to /us a /child is /born;",
        "O come, let /us a_/dore him. /Al_le_/lu_ia.",
    ],
    epiphany: [
        "The Lord hath ma_ni_fes_ted /forth his /glo_ry;",
        "O come, let /us a_/dore him.",
    ],
    lent: [
        "The Lord is full of com_/pass_ion and /mer_cy;",
        "O come, let /us a_/dore him.",
    ],
    easter: [
        "Al_le_lu_ia. The Lord is /ri_sen in_/deed;",
        "O come let us a_dore him. /Al_le_/lu_ia.",
    ],
    ascension: [
        "Al_le_lu_ia. Christ the Lord a_scen_ded /in_to /heav_en;",
        "O come, let /us a_/dore him. /Al_le_/lu_ia.",
    ],
    whitsun: [
        "Al_le_lu_ia. The Spi_rit of the Lord /fill_eth the /world;",
        "O come, let /us a_/dore him. /Al_le_/lu_ia.",
    ],
    trinity: [
        "Fa_ther, Son, and /Ho_ly Ghost, /One God;",
        "O come, let /us a_/dore him.",
    ],
    annunciation: [
        "The Word was made flesh and /dwelt a_/mong us;",
        "O come, let /us a_/dore him.",
    ],
    saints: [
        "The Lord is /glo_ri_ous /in his saints;",
        "O come, let /us a_/dore him.",
    ],
    "ordinary-0": [
        "The earth is the /Lord’s for he /made it;",
        "O come, let /us a_/dore him.",
    ],
    "ordinary-1": [
        "Wor_ship the Lord in the /beau_ty of /ho_li_ness;",
        "O come, let /us a_/dore him.",
    ],
    "ordinary-2": [
        "The mer_cy of the Lord is /e_ver_/last_ing;",
        "O come, let /us a_/dore him.",
    ],
};
